import { ActionMenu } from '@monorepo/shared/componentsV2/menus/ActionMenu';
import { navigateToAdminFormTemplateEditor } from '@monorepo/shared/externalLinks/adminPanel';
import { useNavigateWithReferrerInfo } from '@monorepo/shared/hooks/navigation/useReferrerUrl';
import { useIsSuperAdmin } from '@monorepo/shared/hooks/permissions/useIsSuperAdmin';
import React, { useMemo } from 'react';
import type { FormTemplateRefDisplayRow } from './ViewFormsTable';

interface ViewFormsTableActionsProps {
  form: FormTemplateRefDisplayRow;
}

export function ViewFormsTableActions({ form }: ViewFormsTableActionsProps) {
  const navigateWithReferrerInfo = useNavigateWithReferrerInfo();
  const isSuperAdmin = useIsSuperAdmin();

  const options = useMemo(
    () => [
      {
        displayName: 'Edit',
        onClick: () => navigateWithReferrerInfo(`${form.slug}/edit`),
        disabled: !form.canBeEdited,
      },
      ...(isSuperAdmin
        ? [
            {
              displayName: 'Admin Editor',
              onClick: () =>
                navigateToAdminFormTemplateEditor(form.slug, {
                  openInNewTab: true,
                }),
            },
          ]
        : []),
    ],
    [form.canBeEdited, form.slug, isSuperAdmin, navigateWithReferrerInfo],
  );

  return (
    <ActionMenu
      altText={`Action menu for ${form.name} form`}
      options={options}
    />
  );
}
